import { useContext, useImperativeHandle, useState } from "react";
import patternClose from '../../../../static/img/pattern_close2.png'
import patternScale from '../../../../static/img/pattern_scale2.png'
import patternRote from '../../../../static/img/rote.png'
import textEdit from '../../../../static/img/txt_edit.png'
import TContext from '../../context'
import PContext from '../context'
import Animate from '../../../animate'
import { MenuType } from '../menu'

const cutpartBoxStyle: React.CSSProperties = {
    background: '#ffffff',
    overflow: 'hidden',
}

const canvas2D: any = {
    display: 'block',
    margin: '0 auto',
    touchAction: 'none'
}

export interface Props {
    controPosition?: any
    action?: any
}
const buttonClass = {
    padding: '8px 15px',
    backgroundColor: '#1890ff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    margin: '10px'
};

export interface Action {
    setShow?: (s: boolean) => void; //显示
    setBottom?: (s: number) => void; //设置底部距离
    setUseSafeHeight?: (s: boolean) => void; //是否使用安全高度
}

const paddingHeight = 10
export const Height = paddingHeight + paddingHeight


const Index = (props: Props & { activeMenu?: MenuType }) => {
    const { activeMenu } = props
    const [show, setInnerShow] = useState<boolean>(false)
    const [bottom, setBottom] = useState<number>(0)
    const [useSafeHeight, setUseSafeHeight] = useState<boolean>(true)

    const tc = useContext(TContext)
    const pc = useContext(PContext)


    useImperativeHandle(props.action, () => ({
        setShow,
        setBottom,
        setUseSafeHeight
    }));


    const setShow = (isShow: boolean) => {
        setInnerShow(isShow)
    }
    const handleFullscreen = () => {
        // if (tc?.hasUnsavedChanges && tc?.curActivityObject && tc?.fabricClient) {
        const object = tc.curActivityObject;
        const canvaes = tc.fabricClient.canvaes;
        const currentCanvas = tc.curCutpartCode ? canvaes[tc.curCutpartCode] : undefined;


        if (!currentCanvas) return;

        // 画布尺寸
        const canvasWidth = tc.fabricW || currentCanvas.width || 500;
        const canvasHeight = tc.fabricW || currentCanvas.height || 500;
        const targetScale = canvasWidth / object.width;

        // 应用变换 - 直接使用画布尺寸
        object.set({
            scaleX: targetScale,
            scaleY: targetScale, // 保持宽高比
            left: canvasWidth / 2,
            top: canvasHeight / 2,
            originX: 'center',
            originY: 'center'
        });

        currentCanvas.renderAll();

        if (tc.markAsChanged) {
            tc.markAsChanged();
        }
        // }else{
        //     console.log("无未保存的变化")
        // }
    };
    return (
        <Animate show={show} style={{
            width: "100%",
            position: "fixed",
            margin: '0 auto',
            zIndex: 11,
            bottom,
            paddingBottom: useSafeHeight ? 'env(safe-area-inset-bottom)' : 0,
            ...cutpartBoxStyle
        }}>
            <div style={{ height: paddingHeight }}></div>
            <div style={{
                width: tc.fabricW,
                height: activeMenu === MenuType.SUCAI ? (tc.fabricW || 0) - 50 : (tc.fabricW || 0),
                position: 'relative',
                margin: '0 auto',
                border: '1px solid rgba(0,0,0,0.1)',
                overflow: "hidden"
            }}>
                <div style={{ width: '100%', height: '100%' }}>
                    <div>
                        {
                            tc?.detailData?.model_materials?.cutparts?.map((v: any) => (
                                <div key={v.code} style={{
                                    display: tc.curCutpartCode === v.code ? 'flex' : 'none',
                                    justifyContent: 'center',
                                    width: tc.fabricW,
                                    height: tc.fabricW,
                                    position: 'relative',
                                    margin: "0 auto",
                                    overflow: 'hidden',
                                }}>
                                    <canvas id={v.code} style={canvas2D}></canvas>
                                    <div style={{
                                        position: "absolute",
                                        width: tc.fabricW,
                                        height: tc.fabricW,
                                        left: 0,
                                        top: 0,
                                        pointerEvents: "none",
                                        background: `url(${v.img})`,
                                        backgroundSize: `100% 100%`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center center",
                                    }} />
                                </div>
                            ))
                        }
                    </div>
                    {
                        tc.controPosition && <>
                            <img src={patternClose} onClick={pc?.onDelCutpartObject} style={{ height: 19, width: 19, zIndex: 9, position: 'absolute', ...tc?.controPosition?.tl_position }} alt="" />
                            <img src={patternScale} style={{ pointerEvents: "none", height: 19, width: 19, zIndex: 9, position: 'absolute', ...tc?.controPosition?.br_position }} alt="" />
                            <img src={patternRote} style={{ pointerEvents: "none", height: 19, width: 19, zIndex: 9, position: 'absolute', ...tc?.controPosition?.tr_position }} alt="" />
                            {
                                tc?.curActivityObject.type === "text" && <img src={textEdit} onClick={pc?.onEditText} style={{ height: 19, width: 19, zIndex: 9, position: 'absolute', ...tc?.controPosition?.bl_position }} alt="" />
                            }
                        </>
                    }
                </div>
            </div>
            {activeMenu === MenuType.SUCAI && (
                <button
                    style={{ ...buttonClass }}
                    onClick={handleFullscreen}
                >
                    {t('占满画布')}
                </button>
            )}

            <div style={{ height: paddingHeight }}></div>
        </Animate>
    )
}

export default Index